export { LeaderboardService } from './leaderboard.service';
export { leaderboardReducer } from './leaderboard.reducer';
export { watchLeaderboard } from './leaderboard.saga';
import { getLeaderboard } from './leaderboard.action';

export const LeaderboardAction = {
  getLeaderboard,
};